import template from "./product-tailored-card.html";

const ProductCardComponent = {
  template: template,
  controller: class ProductTailoredCardController {
    /* @ngInject */
    constructor($rootScope, $window) {
      this.$rootScope = $rootScope;
      this.$window = $window;
    }

    openTailoredContact() {
      this.$window.open(
        "https://help.smartvault.com/hc/en-us/requests/new",
        "_blank"
      );      
    }
  },
};

export default ProductCardComponent;
